var a=Object.defineProperty;var o=Object.getOwnPropertyDescriptor;var u=Object.getOwnPropertyNames;var l=Object.prototype.hasOwnProperty;var s=(i,e,r,t)=>{if(e&&typeof e=="object"||typeof e=="function")for(let n of u(e))!l.call(i,n)&&n!==r&&a(i,n,{get:()=>e[n],enumerable:!(t=o(e,n))||t.enumerable});return i};var v=i=>s(a({},"__esModule",{value:!0}),i);var m={};module.exports=v(m);



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/external/react-native-view/components/Animated/types.ts